<mat-card>
    <mat-card-header>
        <p i18n>request works!</p>
    </mat-card-header>
    <mat-card-content>
        <span i18n>We have noticed your request for the role of </span>{{requested_role}}.
    </mat-card-content>
</mat-card>
